import React from 'react'
import { FormatOptionLabelMeta } from 'react-select'
import { IUserModel } from '../interfaces/models/users.interfaces'
import { TicketAvatar, UserAvatar } from '../components/common/Avatar'
import { theme } from '../theme/theme'
import { getUserFullName } from '../helpers/user'

type optionLabelReturnType = {
  (data: unknown, { context }: FormatOptionLabelMeta<unknown>): JSX.Element
}

export const useFormatUserOptionLabel = (): optionLabelReturnType => {
  const formatOptionLabel = (
    data: unknown,
    { context }: FormatOptionLabelMeta<unknown>
  ): JSX.Element => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const dataAsAny = data as any
    const user = dataAsAny.data as IUserModel & {
      avatarUrl?: string
      unitString?: string
    }
    const fullName = getUserFullName(user)
    const label = `${fullName}${user.unitString ? `, ${user.unitString}` : ''}`

    return context === 'menu' ? (
      <div className="flex items-center gap-3">
        {user.avatarUrl ? (
          <TicketAvatar user={user} url={user.avatarUrl} />
        ) : (
          <UserAvatar user={user} />
        )}
        <p translate="no" style={theme.textVariants.base}>
          {label}
        </p>
      </div>
    ) : (
      <p translate="no" style={theme.textVariants.base}>
        {label}
      </p>
    )
  }

  return formatOptionLabel
}
